import { render } from "./ListMarkedData.vue?vue&type=template&id=d1886444"
import script from "./ListMarkedData.vue?vue&type=script&lang=js"
export * from "./ListMarkedData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__